import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Slidar } from '../AdminDashbord/Slidar';
import './AdminTestimonial.css';

const AdminAchievements = () => {
  const [achievement, setAchievement] = useState({ title: '', desc: '' });
  const [achievementImage, setAchievementImage] = useState(null);
  const [achievements, setAchievements] = useState([]);
  const [editAchId, setEditAchId] = useState(null);
  const [showAchForm, setShowAchForm] = useState(false);

  const BASE_URL = '';

  useEffect(() => {
    fetchAchievements();
  }, []);

  const fetchAchievements = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/achievements`);
      setAchievements(res.data);
    } catch (err) {
      console.error("Error fetching achievements:", err);
    }
  };

  const handleAchievementSubmit = async () => {
    const formData = new FormData();
    formData.append('img', achievementImage);
    formData.append('title', achievement.title);
    formData.append('desc', achievement.desc);

    try {
      if (editAchId) {
        await axios.put(`${BASE_URL}/api/achievements/${editAchId}`, formData);
        alert("Achievement updated");
        setEditAchId(null);
      } else {
        await axios.post(`${BASE_URL}/api/achievements`, formData);
        alert("Achievement added");
      }
      setAchievement({ title: '', desc: '' });
      setAchievementImage(null);
      setShowAchForm(false);
      fetchAchievements();
    } catch (err) {
      alert("Failed to save achievement");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this achievement?")) {
      try {
        await axios.delete(`${BASE_URL}/api/achievements/${id}`);
        fetchAchievements();
      } catch (err) {
        alert("Failed to delete");
      }
    }
  };

  const handleEdit = (a) => {
    setAchievement({ title: a.title, desc: a.desc });
    setEditAchId(a._id);
    setShowAchForm(true);
  };

  return (
    <div className="admin-testimonial-container">
      <Slidar />
      <div className="admin-testimonial-content">
        <div style={{ textAlign: 'right' }}>
          <button
            className="toggle-ach-btn"
            onClick={() => {
              setShowAchForm(!showAchForm);
              setEditAchId(null);
              setAchievement({ title: '', desc: '' });
              setAchievementImage(null);
            }}
          >
            {showAchForm ? '❌ Close Form' : '➕ Add Logo'}
          </button>
        </div>

        {showAchForm && (
          <div>
            <h2>{editAchId ? "Edit" : "Add"} estimated customer</h2>
            <label>Add Logo</label>
            <input type="file" accept="image/*" onChange={e => setAchievementImage(e.target.files[0])} />
             <label>Title</label>
            <input placeholder="Title" value={achievement.title} onChange={e => setAchievement({ ...achievement, title: e.target.value })} />
             <label>Description</label>
            <input placeholder="Description" value={achievement.desc} onChange={e => setAchievement({ ...achievement, desc: e.target.value })} />
            <button onClick={handleAchievementSubmit}>{editAchId ? "Update" : "Add"} Achievement</button>
          </div>
        )}

        <table className="admin-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {achievements.map(a => (
              <tr key={a._id}>
                <td><img src={a.img.startsWith('http') ? a.img : `${BASE_URL}${a.img}`} alt={a.title} />
</td>
                <td>{a.title}</td>
                <td>{a.desc}</td>
                <td>
                  <button className="edit-btn" onClick={() => handleEdit(a)}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDelete(a._id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminAchievements;
